/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_import_targets_endpoint_api_v1_performance_targets_import_post } from '../models/Body_import_targets_endpoint_api_v1_performance_targets_import_post';
import type { PnlProgressUpsert } from '../models/PnlProgressUpsert';
import type { SuccessResponse_PerformanceOverviewResponse_ } from '../models/SuccessResponse_PerformanceOverviewResponse_';
import type { SuccessResponse_PerformanceStoreDetailResponse_ } from '../models/SuccessResponse_PerformanceStoreDetailResponse_';
import type { SuccessResponse_PnlProgressUpsertResponse_ } from '../models/SuccessResponse_PnlProgressUpsertResponse_';
import type { SuccessResponse_TargetImportResponse_ } from '../models/SuccessResponse_TargetImportResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceService {
    /**
     * Overview Endpoint
     * GET /api/v1/performance/overview — 各店绩效概览 (RLS-scoped, 只读)。
     * @returns SuccessResponse_PerformanceOverviewResponse_ Successful Response
     * @throws ApiError
     */
    public static overviewEndpointApiV1PerformanceOverviewGet({
        month,
    }: {
        /**
         * YYYY-MM
         */
        month: string,
    }): CancelablePromise<SuccessResponse_PerformanceOverviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance/overview',
            query: {
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Store Detail Endpoint
     * GET /api/v1/performance/stores/{store_id} — 单店完整预估 P&L (跨店 → 404, PIT-018)。
     * @returns SuccessResponse_PerformanceStoreDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static storeDetailEndpointApiV1PerformanceStoresStoreIdGet({
        storeId,
        month,
    }: {
        storeId: number,
        /**
         * YYYY-MM
         */
        month: string,
    }): CancelablePromise<SuccessResponse_PerformanceStoreDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/performance/stores/{store_id}',
            path: {
                'store_id': storeId,
            },
            query: {
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Targets Endpoint
     * POST /api/v1/performance/targets/import — 上传月度目标 (zip/xlsx) 入库。
     *
     * 按月覆盖 (DELETE 当月 + INSERT, 事务)。stdlib 解析 (zipfile + xml.etree)。
     * 非合法 xlsx/zip / XML 含 DOCTYPE/超解压上限 → 422 PERFORMANCE_IMPORT_INVALID_FILE。
     * @returns SuccessResponse_TargetImportResponse_ Successful Response
     * @throws ApiError
     */
    public static importTargetsEndpointApiV1PerformanceTargetsImportPost({
        formData,
    }: {
        formData: Body_import_targets_endpoint_api_v1_performance_targets_import_post,
    }): CancelablePromise<SuccessResponse_TargetImportResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/performance/targets/import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upsert Progress Endpoint
     * PUT /api/v1/performance/progress — 月末财务真账 upsert (跨店 → 404, PIT-018)。
     * @returns SuccessResponse_PnlProgressUpsertResponse_ Successful Response
     * @throws ApiError
     */
    public static upsertProgressEndpointApiV1PerformanceProgressPut({
        requestBody,
    }: {
        requestBody: PnlProgressUpsert,
    }): CancelablePromise<SuccessResponse_PnlProgressUpsertResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/performance/progress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
